var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0443 11.2444C16.8128 13.4193 15.5805 15.4574 13.5413 16.6347C10.1534 18.5907 5.82132 17.4299 3.86531 14.042L3.65698 13.6812M2.95527 9.75602C3.18677 7.58111 4.4191 5.543 6.45825 4.3657C9.84616 2.40969 14.1783 3.57047 16.1343 6.95838L16.3426 7.31922M2.91113 15.5552L3.52118 13.2785L5.79788 13.8886M14.2022 7.11186L16.4789 7.7219L17.0889 5.44519",
    stroke: "#26404E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.15ab20f3e15c51c1875ae1411f2d3908.svg";
export { ForwardRef as ReactComponent };